import React from 'react';
import { Calendar, Clock, AlertCircle } from 'lucide-react';

const Colaborari = () => {
  return (
    <div className="page-surface py-20 sm:py-24">
      <div className="max-w-4xl mx-auto px-5">
        <div className="mb-12 max-w-3xl">
          <p className="eyebrow">Cum colaborăm</p>
          <h1 className="page-heading mt-5 font-bold">Reguli clare pentru un ritm bun.</h1>
          <p className="mt-5 text-xl text-gray-600">Plată, recuperări și excepții, explicate simplu.</p>
        </div>

        {/* Plată */}
        <div className="mb-8 rounded-[2rem] border border-blue-100 bg-white p-8 shadow-float">
          <div className="flex items-center mb-6">
            <Calendar className="h-8 w-8 text-blue-600 mr-4" />
            <h2 className="text-2xl font-bold">Plată</h2>
          </div>
          <p className="text-gray-700">
            Se face în avans, pentru întreaga lună, la începutul fiecărei luni.
          </p>
        </div>

        {/* Politica pentru absențe și recuperări */}
        <div className="mb-8 rounded-[2rem] border border-blue-100 bg-white p-8 shadow-float">
          <div className="flex items-center mb-6">
            <Clock className="h-8 w-8 text-blue-600 mr-4" />
            <h2 className="text-2xl font-bold">Politica pentru absențe și recuperări</h2>
          </div>
          <p className="text-gray-700 mb-4">
            Oferim flexibilitate în cazul absențelor:
          </p>
          <ul className="space-y-4 text-gray-700">
            <li className="flex items-start">
              <span className="inline-block w-2 h-2 bg-blue-600 rounded-full mt-2 mr-3"></span>
              <span>
                Dacă știm din timp că nu se poate participa la ședință, vă rugăm să ne anunțați cu cel 
                puțin 24 de ore înainte; astfel ședința poate fi recuperată fie în săptămâna respectivă, 
                fie în cea imediat următoare, în funcție de disponibilitate.
              </span>
            </li>
            <li className="flex items-start">
              <span className="inline-block w-2 h-2 bg-blue-600 rounded-full mt-2 mr-3"></span>
              <span>
                Dacă nu se dorește recuperarea, suma achitată pentru ședința respectivă va fi returnată.
              </span>
            </li>
            <li className="flex items-start">
              <span className="inline-block w-2 h-2 bg-blue-600 rounded-full mt-2 mr-3"></span>
              <span>
                În cazul în care absența este anunțată în ziua ședinței, suma nu poate fi restituită, 
                întrucât organizarea și resursele au fost deja alocate.
              </span>
            </li>
          </ul>
        </div>

        {/* Excepții speciale */}
        <div className="rounded-[2rem] border border-blue-100 bg-white p-8 shadow-float">
          <div className="flex items-center mb-6">
            <AlertCircle className="h-8 w-8 text-blue-600 mr-4" />
            <h2 className="text-2xl font-bold">Excepții speciale</h2>
          </div>
          <p className="text-gray-700 mb-4">
            Înțelegem că pot exista situații care necesită flexibilitate. Așadar, următoarele momente 
            sunt exceptate de la regulile obișnuite:
          </p>
          <ul className="space-y-4 text-gray-700">
            <li className="flex items-start">
              <span className="inline-block w-2 h-2 bg-blue-600 rounded-full mt-2 mr-3"></span>
              <span>
                Vacanțele școlare și sărbătorile legale, care sunt perioade dedicate relaxării și familiei.
              </span>
            </li>
            <li className="flex items-start">
              <span className="inline-block w-2 h-2 bg-blue-600 rounded-full mt-2 mr-3"></span>
              <span>
                Concediile planificate, pentru care vă rugăm să ne anunțați din timp.
              </span>
            </li>
            <li className="flex items-start">
              <span className="inline-block w-2 h-2 bg-blue-600 rounded-full mt-2 mr-3"></span>
              <span>
                Situațiile care necesită o scutire medicală, prioritizând sănătatea și binele fiecărui cursant.
              </span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Colaborari;
